// extracted by mini-css-extract-plugin
module.exports = {"background":"TeamGrid_background__21QVq","guidegrid":"TeamGrid_guidegrid__39gq9"};